// src/utils/recordingMode/clinicAssocErrorKey.js
export function clinicAssocErrorKey(reason) {
  switch (reason) {
    case "missing_fields":
      return "clinicAssoc.missingFields";
    case "not_found":
      return "clinicAssoc.notFound";
    case "not_allowed":
      return "clinicAssoc.notAllowed";
    case "fetch_failed":
    default:
      return "clinicAssoc.fetchFailed";
  }
}
